export const FETCH_EXISTING_SUBDIMENSIONS_REQUEST =
  "FETCH_EXISTING_SUBDIMENSIONS_REQUEST";

export const FETCH_EXISTING_SUBDIMENSIONS_SUCCESS =
  "FETCH_EXISTING_SUBDIMENSIONS_SUCCESS";

export const FETCH_EXISTING_SUBDIMENSIONS_FAILURE =
  "FETCH_EXISTING_SUBDIMENSIONS_FAILURE";

export const fetchExistingSubdimensionsRequest = (payload) => ({
  type: FETCH_EXISTING_SUBDIMENSIONS_REQUEST,
  payload,
});

export const fetchExistingSubdimensionsSuccess = (data) => ({
  type: FETCH_EXISTING_SUBDIMENSIONS_SUCCESS,
  payload: data,
});

export const fetchExistingSubdimensionsFailure = (error) => ({
  type: FETCH_EXISTING_SUBDIMENSIONS_FAILURE,
  payload: error,
});
